import * as moment from 'moment';

import { Component, Input, Output, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { CustomerService } from '../../../../../../../../../../services/customer/customer.service';
import { dateStringFromISO8601, propExists } from '../../../../../../../../../../utils';
import { CustomerMembership, CustomerMembershipCustomer } from '../../../../../../../../../../models/membership';
import { OrganizationConfigService } from '../../../../../../../../../../services/organization-config/organization-config.service';

@Component({
  selector: 'app-edit-recurring-customer-membership-schedule-unfreeze-individual',
  templateUrl: './edit-recurring-customer-membership-schedule-unfreeze-individual.component.html',
  styleUrls: ['./edit-recurring-customer-membership-schedule-unfreeze-individual.component.css']
})
export class EditRecurringCustomerMembershipScheduleUnfreezeIndividualComponent implements OnInit, OnDestroy {

  @Input() membership: CustomerMembership;
  @Input() savedCallback: (successMessage: string) => undefined;
  @Input() saveClickedObservable: Observable<void>;
  @Output() loadingEvent = new EventEmitter<boolean>();
  @Output() serverErrorEvent = new EventEmitter<number>();

  public member: CustomerMembershipCustomer;
  public unfreezeDate: string = null;

  // The number of days from now (positive = future, negative = past) of the
  // selected effective date.
  public unfreezeDaysFromNow: number = null;

  public errorMessage = '';

  public UNFREEZE_DATE_IMMEDIATELY = 'immediately';
  public dateStringFromISO8601 = dateStringFromISO8601;

  private saveClickedSubscription: Subscription;

  constructor(
    private activeModal: NgbActiveModal,
    private customerService: CustomerService
  ) {}

  ngOnInit() {
    this.saveClickedSubscription = this.saveClickedObservable.subscribe(() => {
      this.handleSave();
    });

    for (const member of this.getActionableMembers()) {
      this.member = member
    }
  }

  ngOnDestroy() {
    this.saveClickedSubscription.unsubscribe();
  }

  public updateUnfreezeDaysFromNow() {
    if (!propExists(this.unfreezeDate)) {
      this.unfreezeDaysFromNow = null;
    } else if (this.unfreezeDate === this.UNFREEZE_DATE_IMMEDIATELY) {
      this.unfreezeDaysFromNow = 0;
    } else {
      this.unfreezeDaysFromNow = moment(this.unfreezeDate).diff(moment(), 'days');
    }
    this.errorMessage = '';
  }

  public getActionableMembers(): CustomerMembershipCustomer[] {
    return this.membership.all_customers.filter(cmc => ((cmc.is_individually_frozen) && (cmc.member_unfreeze_date === null)));
  }

  private handleSave() {
    if (this.unfreezeDate === null) {
      this.errorMessage = 'Please select a date for the unfreeze to take effect.';
      return;
    }

    this.loadingEvent.emit(true);

    this.errorMessage = '';

    let unfreezePromise: Promise<void>;

    if (this.unfreezeDate === this.UNFREEZE_DATE_IMMEDIATELY) {
      unfreezePromise = this.customerService
        .unfreezeMemberImmediately(
          this.member
        )
        .then(() => {
          this.savedCallback('Member successfully unfrozen.');
          this.activeModal.close();
        });
    } else {
      unfreezePromise = this.customerService
        .scheduleMemberUnfreeze(
          this.member,
          this.unfreezeDate
        )
        .then(() => {
          this.savedCallback('Member successfully scheduled to be unfrozen.');
          this.activeModal.close();
        });
    }

    unfreezePromise
      .catch(reason => {
        if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to unfreeze this membership.';
        } else if (reason.status === 400) {
          this.errorMessage = reason.error;
        } else {
          this.serverErrorEvent.emit(reason.status);
        }
      })
      .finally(() => { this.loadingEvent.emit(false); });
  }

}
